import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { getResponseURL } from '@angular/http/src/http_utils';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomEventCommand } from '../../../../commands/hub/custom.event.command';
import { VisitorSettingsCommand } from '../../../../commands/pagination.query.command';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import {
  ConfirmModalActions,
  ConfirmModalData,
} from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import { EventTimeService } from '../../../../services/event.time.service';
import { EditorChoiceStore, InfoStore, ToggleStore } from '../../../../stores/hub.calendar.store';
import { VisitorSettingsStore } from '../../../../stores/visitor.calendar.store';
import { removeHtmlTags } from '../../../../utils/removeHtmlTags';
import { EditEventModalComponent } from '../../edit.event.modal/edit.event.modal.component';
import { EditEventModalActions } from '../../edit.event.modal/edit.event.modal.provider';
import { ShowMoreEventTimesModalComponent } from '../../../../common/components/show.more.event.times.modal/show.more.event.times.modal.component';
import {
  ShowMoreEventTimesModalActions,
  ShowMoreEventTimesModalData,
} from '../../../../common/components/show.more.event.times.modal/show.more.event.times.modal.provider';
import { getRouteUrl, routeConfigs } from '../../../../common/constants/route.config';
import { AuthService } from '../../../../common/services/auth.service';
import { ModalService } from '../../../../common/services/modal.service';
import { EditorChoiceDataSource, HubEvent } from '../../../../models/hub/hub.event';
import { HubTour } from '../../../../models/hub/hub.tour';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { ShowInfoModalComponent } from '../../show.info.modal/show.info.modal.component';
import {
  InfoModalData,
  ShowInfoModalActions,
} from '../../show.info.modal/show.info.modal.provider';
import { HubCalendarComponent } from '../hub.calendar.component';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { isNullOrUndefined } from '../../../../common/extensions';
import { AIEventClassificationModalComponent } from '../../ai.event.classification.modal/ai.event.classification.modal.component';
import {
  AIEventClassificationModalActions,
  AIEventClassificationModalData,
} from '../../ai.event.classification.modal/ai.event.classification.modal.provider';
import { ShowPromptModalComponent } from '../../show.prompt.modal/show.prompt.modal.component';
import {
  PromptModalData,
  ShowPromptModalActions,
} from '../../show.prompt.modal/show.prompt.modal.provider';
import { AlertifyService } from '../../../../services/alertify.service';

@Component({
  selector: 'ig-hub-event-card',
  templateUrl: './hub.event.card.component.html',
  styleUrls: ['./hub.event.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubEventCardComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public descriptionText: string;
  public isOperating: boolean;
  public isSchedulerRunning: boolean;
  public isUpdating = false;
  public editorChoiceText = '';
  public addToEditorChoiceTextTip = 'Add to ';
  public removeFromEditorChoiceTextTip = 'Remove from ';
  public customSettings: VisitorSettingsCommand;
  public toggles = new HubVisitorFeatureToggle();
  @Input() public event: HubEvent;
  @Input() public isItineraryOn: boolean;
  @ViewChildren('card') card: QueryList<ElementRef>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private authService: AuthService,
    private hubApiService: HubApiService,
    public imageService: ImageService,
    private infoStore: InfoStore,
    private editorChoiceStore: EditorChoiceStore,
    private visitorSettingsCommand: VisitorSettingsStore,
    private togglesStore: ToggleStore,
    private alertify: AlertifyService,
    private parent: HubCalendarComponent
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.processDescription();
    this.editorChoiceStore.infoCommand
      .takeUntil(this.isDestroyed)
      .subscribe((editorChoice: EditorChoiceDataSource) => {
        this.editorChoiceText = editorChoice.editorChoiceForEvent;
        this.addToEditorChoiceTextTip += this.editorChoiceText;
        this.removeFromEditorChoiceTextTip += this.editorChoiceText;
      });

    this.visitorSettingsCommand.settingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((settings: VisitorSettingsCommand) => {
        this.customSettings = settings;
      });

    this.togglesStore.toggleCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorFeatureToggle) => {
        this.toggles =
          isNullOrUndefined(toggleCommand) || isNullOrUndefined(toggleCommand.placeCalendar)
            ? new HubVisitorFeatureToggle()
            : toggleCommand;
      });
  }

  public jumpToFacebook() {
    if (this.event.eventLink) {
      window.open(
        this.event.eventLink.startsWith('http')
          ? this.event.eventLink
          : `https://${this.event.eventLink}`
      );
    } else if (this.event.socialName == 'eventbrite') {
      window.open('https://www.eventbrite.com/e/' + this.event.id);
    } else if (this.event.socialName == 'facebook') {
      window.open('https://www.facebook.com/' + this.event.id);
    } else if (this.event.socialName == 'eventful') {
      window.open('http://auckland.eventful.com/events/' + this.event.id);
    }
  }

  public jumpToTicket($event) {
    $event.stopPropagation();
    window.open(
      this.event.ticketUri
        ? this.event.ticketUri.startsWith('http')
          ? this.event.ticketUri
          : `https://${this.event.ticketUri}`
        : ''
    );
  }

  public approve() {
    this.isOperating = true;
    this.hubApiService
      .approveEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isApproved = true;
      });
  }

  public unApprove() {
    this.isOperating = true;
    this.hubApiService
      .unApproveEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isApproved = false;
      });
  }

  public pin() {
    this.isOperating = true;
    this.hubApiService
      .pinEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.parent.pinEvent(this.event);
      });
  }

  public unPin() {
    this.isOperating = true;
    this.hubApiService
      .unPinEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.parent.unPinEvent(this.event);
      });
  }

  public choice() {
    this.isOperating = true;
    this.hubApiService
      .choiceEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isChoice = true;
      });
  }

  public custom() {
    this.isOperating = true;
    this.hubApiService
      .customEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isCustom = true;
      });
  }

  public unChoice() {
    this.isOperating = true;
    this.hubApiService
      .unChoiceEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isChoice = false;
      });
  }

  public unCustom() {
    this.isOperating = true;
    this.hubApiService
      .unCustomEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isCustom = false;
      });
  }

  public toBeExport() {
    this.isOperating = true;
    this.hubApiService
      .toBeExportEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isToBeExport = true;
      });
  }

  public unToBeExport() {
    this.isOperating = true;
    this.hubApiService
      .unToBeExportEvent(this.hubName, this.event._id)
      .finally(() => (this.isOperating = false))
      .subscribe(() => {
        this.event.isToBeExport = false;
      });
  }

  public showEditModal() {
    let actions = <EditEventModalActions>{
      confirm: (event: ButtonTriggerEvent, e: HubEvent, image: string) => {
        this.event = e;
        this.event.cover = {
          source: null,
          isDefault: false,
          isLarge: this.event.cover.isLarge,
        };
        this.event.cover.source = this.imageService.imageSourceUrl(image || null);
        this.processDescription();
      },
    };

    this.event.hubName = this.hubName;
    this.modalService.show({
      component: EditEventModalComponent,
      providers: [
        { provide: EditEventModalActions, useValue: actions },
        { provide: HubEvent, useValue: this.event },
      ],
      panelClass: ['width-modal-4', 'ig-edit-event-modal', 'transition-50'],
    });
  }

  public lock(event: ButtonTriggerEvent) {
    this.hubApiService
      .lock(this.hubName, this.event._id)
      .finally(event.complete)
      .subscribe(() => {
        this.event.isLocked = true;
      });
  }
  public unlock(event: ButtonTriggerEvent) {
    this.hubApiService
      .unlock(this.hubName, this.event._id)
      .finally(event.complete)
      .subscribe(() => {
        this.event.isLocked = false;
      });
  }

  /** logic delete */
  public remove() {
    if (this.event.isManuallyCreated) {
      this.deletePermanently();
      return;
    }

    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .removeEvent(this.hubName, this.event._id)
          .finally(event.complete)
          .subscribe(() => {
            this.parent.removeEvent(this.event, false);
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      // confirmModalDescription: 'Are you sure you want to block this event, all events belong to this organizer will be blocked too?',
      confirmModalDescription: 'Are you sure you want to delete this event?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public block() {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .block(this.hubName, this.event._id)
          .finally(event.complete)
          .subscribe(() => {
            this.parent.removeEvent(this.event);
            const doNotShowModal = localStorage.getItem(
              localStorageKeys.doNotShowRemoveSuccessfullyModal
            );
            if (!doNotShowModal) {
              this.showRmoveSuccessModal();
            }
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this event?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  /**
   * remove the delete event button for pulled events, as some clients are confused that if they delete an event, it will be added in the next pull
   * */
  public deletePermanently() {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteEvent(this.hubName, this.event._id)
          .finally(event.complete)
          .subscribe(() => {
            this.parent.removeEvent(this.event);
          });
      },
      cancel: () => {
        this.isOperating = false;
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription:
        'Are you sure you want to remove this event permanently, this operation cannot be reverted.',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public showMoreTimes($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();

    let actions = <ShowMoreEventTimesModalActions>{
      confirm: () => { },
    };

    let data = <ShowMoreEventTimesModalData>{
      title: this.event.title,
      eventTimes: this.event.eventTimes,
      eventTimesText: this.event.eventTimesText,
      timezone: this.event.timezone,
      isManualTime: !!this.event.startTimeText,
    };

    this.modalService.show({
      component: ShowMoreEventTimesModalComponent,
      providers: [
        { provide: ShowMoreEventTimesModalActions, useValue: actions },
        { provide: ShowMoreEventTimesModalData, useValue: data },
      ],
    });
  }

  public addOrRemoveToCustomBtn(btn: CustomEventCommand, index: number) {
    if (!this.isInCustomBtn(btn)) {
      this.hubApiService
        .addEventToCustomBtn(this.hubName, this.event._id, index)
        .subscribe((customEvents) => {
          this.parent.customBtns.events = customEvents;
        });
    } else {
      this.hubApiService
        .removeEventFromCustomBtn(this.hubName, this.event._id, index)
        .subscribe((customEvents) => {
          this.parent.customBtns.events = customEvents;
        });
    }
  }

  public addOrRemoveFromTour(tour: HubTour) {
    if (!this.isInTour(tour)) {
      this.hubApiService
        .addAttractionToTour(this.hubName, {
          id: tour._id,
          feedType: 'event',
          feedId: this.event._id,
        })
        .subscribe(() => {
          const currentTour = this.parent.tours.find(x => x._id === tour._id);
          if (currentTour) {
            currentTour.days[0].attractions.push({             
              feedId: this.event._id,
              feedType: 'event',
            });
          }
          // this.hubApiService.getTours(this.hubName)
          //   .subscribe((tours) => {
          //     this.parent.tours = tours;
          //   });
        });
    } else {
      this.hubApiService
        .removeAttractionFromTour(this.hubName, {
          id: tour._id,
          attractionId: this.event._id,
          feedType: 'event',
        })
        .subscribe(() => {
          // this.hubApiService.getTours(this.hubName)
          //   .subscribe((tours) => {
          //     this.parent.tours = tours;
          //   });
          const currentTour = this.parent.tours.find((x) => x._id === tour._id);
          if (currentTour) {
            currentTour.days.forEach((day) => {
              day.attractions = day.attractions.filter((x) => x.feedId !== this.event._id);
            });
          }
        });
    }
  }

  public async gotoTours() {
    await this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.tours, {
        hubName: this.hubName,
      })
    );
  }

  public isInTour(tour?: HubTour) {
    if (tour) {
      return tour.days.some((x) => x.attractions.some((x) => x.feedId === this.event._id));
    } else {
      if (!this.parent.tours) {
        return false;
      }
      return this.parent.tours.some(tour => 
        tour.days.some(day => 
          day.attractions.some(attraction => 
            attraction.feedId === this.event._id
          )
        )
      );
    }
  }

  public isInCustomBtn(btn?: CustomEventCommand) {
    if (btn) {
      return btn.events.any((x) => x === this.event._id);
    } else {
      let isIn = false;
      if (this.parent.customBtns.events) {
        for (let x of this.parent.customBtns.events) {
          if (x.events.any((x) => x === this.event._id)) {
            isIn = true;
            break;
          }
        }
      }
      return isIn;
    }
  }

  public aiCategory() {
    this.modalService.show({
      component: AIEventClassificationModalComponent,
      providers: [
        { provide: AIEventClassificationModalActions, useValue: null },
        {
          provide: AIEventClassificationModalData,
          useValue: { hubName: this.hubName } as AIEventClassificationModalData,
        },
      ],
      panelClass: 'width-modal-70p',
    });
  }

  public updateEvent($event) {
    if ($event) {
      $event.stopPropagation();
    }
    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData('Update Event', null, [
            'Start updating Facebook event, please read the status on the console tab.',
          ]),
        },
      ],
      panelClass: 'width-modal-2',
    });
    if (this.event.socialName === 'facebook|spider') {
      if (this.event.eventLink) {
        this.hubApiService
          .updateFBSpiderEvent(this.hubName, this.event.eventLink)
          .subscribe((result) => {
            console.log(JSON.stringify(result));

            if (!result.error) {
              this.event.name = this.event.title = result.data.title;
              this.event.hostLink = result.data.host.hostLink;
              this.event.owner.name = result.data.host.hostName;
              this.event.cover.source = result.data.img.imgUrl;
              this.event.description = result.data.description;
              this.event.address = result.data.address;
              this.event.ticketUri = result.data.ticketUrl;
              this.event.eventTimes = result.data.time.eventTimes;
              this.event.startTime = result.data.time.startTime;
              this.event.endTime = result.data.time.endTime;
              this.event.timezone = result.data.time.timezone;
              this.processDescription();
              EventTimeService.processEventTime(this.event);
              console.log(`update finished successfully`);
            } else {
              this.infoStore.infoCommand.next(result.msg);
              console.log('update error :', result.msg);
            }
            // this.closeSocket();
          });
      } else {
        this.infoStore.infoCommand.next(
          `<span style="color:red">This event hasn't a link, please check.</span>`
        );
        console.log(`This event hasn't a link, please check.`);
      }
    } else {
      this.infoStore.infoCommand.next(
        `<span style="color:red">This is not a Facebook event, please check.</span>`
      );
      console.log(`This is not a Facebook event, please check`);
    }
  }

  private processDescription() {
    if (!this.event.description || this.event.description === 'undefined') {
      this.descriptionText = '(no description)';
    } else {
      let text = removeHtmlTags(this.event.description);
      if (text.length > 150) {
        this.descriptionText = text.substr(0, 150).concat('...');
      } else {
        this.descriptionText = text;
      }
    }
  }

  private showRmoveSuccessModal() {
    this.modalService.show({
      component: ShowPromptModalComponent,
      providers: [
        { provide: ShowPromptModalActions, useValue: null },
        {
          provide: PromptModalData,
          useValue: new PromptModalData('Remove successfully', null, [
            'The selected item has been successfully removed from the dashboard.',
            'You can restore this item from the Removed List at any time.',
            'While in the Removed List, this item cannot be pulled again.',
          ]),
        },
      ],
      panelClass: 'width-modal-2',
    });
  }

  public async enlargeImage($event: Event) {
    if ($event) {
      $event.stopPropagation();
    }

    if (this.isOperating) return;

    this.isOperating = true;

    this.hubApiService
      .resizeImageFromUnApprovedEvent(this.hubName, this.event._id)
      .finally(() => {
        this.isOperating = false;
      })
      .subscribe(
        (result) => {
          if (result.success) {
            this.event.cover = {
              source: result.url,
              isLarge: true,
            };
          } else {
            this.alertify.error('Something went wrong, please try again.', 3);
          }
        },
        (error) => {
          console.error('Error enlarging image', error);
        }
      );
  }

  get shouldShowEnlargeImage(): boolean {
    if (
      !this.event ||
      !this.event.socialName ||
      !this.event.cover ||
      !this.event.cover.source ||
      this.event.cover.isLarge
    ) {
      return false;
    }

    // only show the enlarge image for newly pulled events
    return (
      this.event.socialName.includes('serp|google') &&
      !this.event.cover.isLarge &&
      new Date(this.event.createdAt).getTime() > new Date('2025-02-26').getTime()
    );
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/calendar/event.card/hub.event.card.component.ts